// Load all the channels within this directory and all subdirectories.
// Channel files must be named *_channel.js.

// Note: esbuild doesn't support require.context like Webpack does.
// Since we don't have any channel files currently, this is just a placeholder.
// When adding channels, import them explicitly here:
// import "./consumer"
// import "./example_channel"
